/* tslint:disable */
/* eslint-disable */
/**
 * B2B Auth
 * Authentication API  # Tracking Metrics * `b2bportal.auth.session.create.failure`   * tags: `api_version`, `auth_method`, `error_code`, `is_merge`, `new_user`, `tenantid` * `b2bportal.auth.session.create.success`   * tags: `api_version`, `auth_method`, `is_merge`, `new_user`, `tenantid` * `b2bportal.auth.session.info.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.info.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.refresh.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.refresh.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.remove.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.session.remove.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.session.verify.failure`   * tags: `error_code`, `tenantid` * `b2bportal.auth.session.verify.latency`   * tags: `tenantid` * `b2bportal.auth.session.verify.success`   * tags: `tenantid` * `b2bportal.auth.user.finalized.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.user.finalized.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.user.info.update.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.user.info.update.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.verification_code.resend.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.verification_code.resend.success`   * tags: `api_version`, `tenantid` * `b2bportal.auth.verification_code.send.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.auth.verification_code.send.success`   * tags: `api_version`, `tenantid`   # Tracking Error Codes * `already_finalized` * `authentication_method_not_implemented` * `bad_request` * `booking_scope_required` * `cannot_finalize_guest` * `deleted_user` * `email_taken` * `existing_session_token` * `existing_session` * `expired_code` * `expired_token` * `ineligible` * `internal_error` * `invalid_code` * `invalid_email` * `invalid_hash` * `invalid_id` * `invalid_phone_number` * `invalid_token` * `malformed_session` * `merged_user` * `no_session_token` * `not_verified` * `phone_number_taken` * `price_watch_scope_required` * `rejected_session` * `request_deserialization_error` * `response_serialization_error` * `send_failed` * `server_error` * `too_many_user_for_device` * `unauthorized` * `unknown` * `user_does_not_exist` * `user_not_found`  
 *
 * The version of the OpenAPI document: v0p40
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
}
